export const APP_ROUTES = {
  HOME: '/',
  AI_REPORT: '/aireports',
  MY_SMART_DIETS: '/my-smart-diets',
  SMART_REPORT_LIST: '/smartreportlist',
};
